'use client';
import { useState } from 'react';

export default function CalculatorHouseAffordability() {
  const [annualIncome, setAnnualIncome] = useState(75000);
  const [monthlyDebts, setMonthlyDebts] = useState(500);
  const [downPayment, setDownPayment] = useState(50000);
  const [interestRate, setInterestRate] = useState(6.5);

  const monthlyIncome = annualIncome / 12;
  const maxMonthlyPayment = monthlyIncome * 0.28 - monthlyDebts;
  const maxLoanAmount = maxMonthlyPayment / (interestRate / 100 / 12) * (1 - Math.pow(1 + interestRate / 100 / 12, -360));
  const maxHomePrice = maxLoanAmount + downPayment;

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Your Financial Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Annual Income</label>
          <input type="number" value={annualIncome} onChange={(e) => setAnnualIncome(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Monthly Debts</label>
          <input type="number" value={monthlyDebts} onChange={(e) => setMonthlyDebts(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Down Payment</label>
          <input type="number" value={downPayment} onChange={(e) => setDownPayment(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Interest Rate (%)</label>
          <input type="number" step="0.1" value={interestRate} onChange={(e) => setInterestRate(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
      </div>
      <div className="mt-8 p-6 bg-emerald-50 rounded-xl">
        <h3 className="text-lg font-bold mb-2">Maximum Home Price</h3>
        <p className="text-3xl font-bold text-emerald-600">${maxHomePrice?.toFixed(0)}</p>
        <p className="text-sm text-slate-600 mt-2">Maximum Monthly Payment: ${maxMonthlyPayment?.toFixed(2)}</p>
      </div>
    </div>
  );
}
